import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledConditionItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'start',
  },
}));

const StyledConditionItemColumn = styled(Box)(({ theme }) => ({
  flex: 1,

  [theme.breakpoints.down('md')]: {
    width: '100%',
    flex: 'unset',
  },
}));

const titleStyle = {
  fontSize: '14px',
  fontWeight: 700,
};

const conditionsBox = {
  display: 'flex',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  rowGap: '8px',
  padding: '9px 0',
};

const delayTitle = {
  fontSize: '14px',
  fontWeight: 400,
};

export { StyledConditionItem, StyledConditionItemColumn, titleStyle, conditionsBox, delayTitle };
